const BgVector1 = ({ color, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="390"
      height="444"
      viewBox="0 0 390 444"
      fill="none"
      className={className}
    >
      <g opacity="0.32" filter="url(#filter0_f_1061_24229)">
        <path
          d="M194.39 -121.488C88.6683 -113.353 -78.604 107.479 26.25 91.7032C49.6857 88.1773 61.8649 81.6007 84.1738 73.6021C124.817 59.0298 148.096 6.36778 185.138 28.5502C223.952 51.7936 162.106 105.458 185.138 144.398C229.947 220.156 366.86 141.527 393.101 57.5121C424.238 -42.1825 298.526 -129.502 194.39 -121.488Z"
          fill={color || "#DD990A"}
        />
      </g>
      <defs>
        <filter
          id="filter0_f_1061_24229"
          x="-275.702"
          y="-390.702"
          width="942.332"
          height="834.404"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="134.351"
            result="effect1_foregroundBlur_1061_24229"
          />
        </filter>
      </defs>
    </svg>
  );
};
export default BgVector1;
